<div class="filter-control">
  <fsx-select
    label="Queue"        
    [control]="formControl"
    [options]="queueOptions">
  </fsx-select>
</div>